import { initializeApp } from 'firebase/app';
import { getDatabase, connectDatabaseEmulator } from 'firebase/database';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
// pass the configuration object (JSON) with the firebase params
// depending on the environment
// e.g. {
//	 	"apiKey": "...",
// 	"authDomain": "...",
// 	"databaseURL": "...",
// 	"projectId": "...",
// 	...
// 	}
var firebaseConfig = process.env.firebase_config;
// initialize the app
var app = initializeApp(firebaseConfig);
var database = getDatabase(app);
var storage = getStorage(app);
var auth = getAuth();
var functions = getFunctions(app);
// point to the emulator in Dev environment and unpackaged
if (location.hostname === 'localhost' || location.hostname === 'my.localhost') {
    // Point to the RTDB emulator running on localhost.
    // Refers to firebase.json in root path
    connectDatabaseEmulator(database, 'localhost', 9000);
    connectAuthEmulator(auth, 'http://localhost:9099');
    connectStorageEmulator(storage, 'localhost', 9199);
    connectFunctionsEmulator(functions, 'localhost', 5001);
}
export { database, storage, auth, functions };
